import { Link } from 'gatsby';
import * as _ from 'lodash/fp';
import * as React from 'react';
import { Container, Table } from 'semantic-ui-react';


interface Post {
    node: {
        excerpt: string;
        fields: {
            slug: string;
        }
        frontmatter: {
            date: string;
            title: string;
        }
    }
}


interface Props {
    pageTitle?: string;
    posts: Array<Post>;
}


const PostList = ({ pageTitle, posts }: Props) => {
    return (
        <Container>
            <h1>{pageTitle}</h1>
            <Table compact style={{ border: 0 }}>
                <Table.Body>
                    {posts.map(({ node }: any, index) => {
                        const title = _.getOr(
                            node.frontmatter.title,
                            'frontmatter.title',
                            node
                        );
                        return (
                            <Table.Row style={{ border: 0 }} key={index}>
                                <Table.Cell style={{ border: 0 }} textAlign="right">
                                    {node.frontmatter.date}
                                </Table.Cell>
                                <Table.Cell style={{ border: 0 }}>
                                    <Link style={{ color: "black" }} to={node.fields.slug}>
                                        <strong>{title}</strong>
                                    </Link>
                                </Table.Cell>
                            </Table.Row>
                        );
                    })}
                </Table.Body>
            </Table>
        </Container>
    );
};

export default PostList;


